import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { SelectMenu, Button, Tooltip, Paragraph } from "evergreen-ui";
import withAuthentication from "components/withAuthentication/withAuthentication";

class FooterNavigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: null,
      showmenu:false
    };
  }
  authenticatedMenu() {
    const { roles } = this.props;
    return (
      <ul className="footer-navigation">
        {["admin", "clinic"].some((permission) =>
          roles.includes(permission)
        ) && (
          <li>
            <Link to="/account">My account details & alerts</Link>
          </li>
        )}
        <li>
          <Link to="/media">Media Enquiries</Link>
        </li>
        <li>
          <Link to="/funding">Funding for the project</Link>
        </li>
        <li>
          <div className="tooltip TextSize"  onClick={()=>{
            this.setState({showmenu: !this.state.showmenu})
          }}>
            INFORMATION, <br/>INSTRUCTIONS &amp; DOWNLOADS
            {this.state.showmenu && (
              <div className="tooltiptext">
              <ul className='ulTooltip'>
                <li className='liTooltip'><Link to='/about' style={{fontSize:'15px'}}>ABOUT US & HOW IT WORKS</Link></li>
                <li className='liTooltip'><Link to='/instructionHowTo' style={{fontSize:'15px'}}>INSTRUCTIONS HOW TO START TO USE PARVO ALERT</Link></li>
                <li className='liTooltip'><Link to='/downloads' style={{fontSize:'15px'}}>DOWNLOADS</Link></li>
              </ul>
              </div>
            )}
          </div>
        </li>
        <li>
          <Link to="/contact">Contact us</Link>
        </li>
        <li>
          <Link to="/privacy">Privacy, Terms &amp; Conditions</Link>
        </li>
      </ul>
    );
  }

  unAuthenticatedMenu() {
    return (
      <ul className="footer-navigation">
        <li>
          <Link to="/map">Parvo Maps & Alerts</Link>
        </li>
        <li>
          <Link to="/graph">Parvo graphs & hotspots</Link>
        </li>
        <li>
          <Link to="/vaccination">Parvo Vaccination Projects</Link>
        </li>
        <li>
          <Link to="/become-involved">Become Involved</Link>
        </li>
        <li>
          <Link to="/privacy">Privacy, Terms &amp; Conditions</Link>
        </li>
      </ul>
    );
  }

  render() {
    const { isAuthenticated } = this.props;

    return (
      <Fragment>
        {isAuthenticated
          ? this.authenticatedMenu()
          : this.unAuthenticatedMenu()}
      </Fragment>
    );
  }
}

export default withAuthentication(FooterNavigation);
